import { render, staticRenderFns } from "./FormsTemplatesGrid.vue?vue&type=template&id=711bb1f6"
import script from "./FormsTemplatesGrid.vue?vue&type=script&lang=js"
export * from "./FormsTemplatesGrid.vue?vue&type=script&lang=js"
import style0 from "./FormsTemplatesGrid.vue?vue&type=style&index=0&id=711bb1f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports